module.exports = __webpack_public_path__ + "media/5tentative.cea8ead0.mp3";